module.exports = __webpack_public_path__ + "img/404-2.3468041b.svg";